import { withCompInfo } from '@wix/editor-elements-integrations'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import { ColumnCss, ColumnDefinition } from './Column'
import { getWidthCSS, getWidthPixelValue } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<ColumnCss, ColumnDefinition>()(
	[
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'compLayout',
		'compSingleLayout',
		'compId',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		compLayout,
		compSingleLayout,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const backgroundMedia = compDesign?.background || {}

		const fillLayersCSSVars = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compDesign,
			compProps,
			compId,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})

		return {
			...fillLayersCSSVars,
			width: '100%',
			'--column-width': getWidthCSS(compLayout, compSingleLayout),
			'--column-flex': getWidthPixelValue(compLayout, compSingleLayout),
		}
	}
)
